/**
 * MODEL A — MY MODEL (Earlier entry model)
 * Heavy weight on accumulation, absorption, divergence
 * Medium weight on acceleration
 * Mild liquidity penalty, mild distribution penalty
 */
export function computeMyModel(features) {
  const f = normalize(features);

  const raw =
    f.accumulation * 3.0 +
    f.absorption * 2.0 +
    f.divergence * 2.0 +
    f.acceleration * 1.5 +
    f.compression * 0.5 -
    (1 - f.liquidity) * 0.5 -
    f.distribution * 1.0;

  const myScore = clamp(raw, 0, 10);
  const myStage = getStage(myScore);

  return { myScore: round1(myScore), myStage };
}

function normalize(features) {
  return {
    accumulation: sigmoid(features.accumulation5d, 50000),
    absorption: features.absorptionScore || 0,
    divergence: features.divergenceScore || 0,
    acceleration: ((features.accelerationScore || 0) + 1) / 2,
    compression: features.compressionScore || 0,
    liquidity: features.liquidityScore || 0,
    distribution: features.distributionRiskScore || 0,
  };
}

function sigmoid(x, scale) {
  return 1 / (1 + Math.exp(-x / Math.max(scale, 1)));
}

function getStage(score) {
  if (score >= 8.5) return 'CONFIRMED';
  if (score >= 7.5) return 'BUILD';
  if (score >= 6.0) return 'EARLY';
  if (score >= 5.0) return 'WATCH';
  return 'NONE';
}

function clamp(v, min, max) {
  return Math.max(min, Math.min(max, v));
}

function round1(n) {
  return Math.round(n * 10) / 10;
}
